import React, { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';

export const Loader: FC = () => {
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress size={60} />
    </Box>
  );
};
